import React from "react";

export type headingLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export type EventTableHeadingProps = {
  headingLevel?: headingLevel;
  heading: string;
  subheading?: string;
};

const EventTableHeading = ({
  headingLevel = "h1",
  subheading,
  heading,
}: EventTableHeadingProps) => {
  const HeadingTag = headingLevel;
  let headingClass = "cw-heading-base";
  let subheadingClass = "cw-body-base";

  switch (headingLevel) {
    case "h1":
      headingClass = "cw-heading-3xl";
      subheadingClass = "cw-body-xl";
      break;
    case "h2":
      headingClass = "cw-heading-2xl";
      subheadingClass = "cw-body-xl";
      break;
    case "h3":
      headingClass = "cw-heading-xl";
      subheadingClass = "cw-body-lg";
      break;
    case "h4":
      headingClass = "cw-heading-base";
      subheadingClass = "cw-body-base";
      break;
    case "h5":
      headingClass = "cw-heading-sm";
      subheadingClass = "cw-body-sm";
      break;
    case "h6":
      headingClass = "cw-heading-caption";
      subheadingClass = "cw-body-caption";
      break;
  }

  return (
    <div className="cw-flex cw-flex-wrap cw-items-center">
      <div className="cw-flex-grow cw-mr-2">
        <div className="cw-flex cw-flex-wrap cw-items-center">
          <HeadingTag className={`cw-m-0 cw-mr-2 ${headingClass}`}>{heading}</HeadingTag>
          {subheading && <div className={`cw-font-light ${subheadingClass}`}>{subheading}</div>}
        </div>
      </div>
      {/* DevNote: aside to be placed here */}
    </div>
  );
};

export default EventTableHeading;
